import { baseApi } from "../../../../app/api";
import type {
  RawStockNotificationPayload,
  RawStockNotificationResponse,
} from "../../../../types/api/customRestApi/customRestApiEndpointsTypes";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export const stockNotificationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    subscribeToStockNotification: builder.mutation<
      RawStockNotificationResponse,
      RawStockNotificationPayload
    >({
      query: (payload) => ({
        url: `${CUSTOM_REST_API_BASE}/stock-notification/subscribe`,
        method: "POST",
        body: payload,
      }),
      // No tags to invalidate as this doesn't update immediate UI state like cart/wishlist
    }),
  }),
});

export const { useSubscribeToStockNotificationMutation } = stockNotificationApi;
